const vars = {
    // General display
    fontFamily: "Avenir-Next, Helvetica Neu, Helvetica, Sans",
    fontColor: "#424559",
    lightFontColor: "#babcca",
    fontSize: "12pt",

    fontS: "10pt",
    fontM: "12pt",
    fontL: "14pt",
    fontXL: "18pt",

    // Global Colors
    backgroundColor: "#f9f9f9", // This is the very back of the app
    surfaceColor: "white", // This is the color of all the components
    inputBackgroundColor: "white", // This is the color of all the components
    elementHighlightColor: "#ebf5ff", // This is the color of all the components
    linkTextColor: "#2980b9",
    outlineColor: "#ddd",

    brandColor: "#f39c12",
    successColor: "#2ecc71",
    dangerColor: "#e74c3c",

    dividerColor: "#eee",
    dividerThickness: 1,

    borderThickness: "1px",
    borderRadius: "5px",

    // Layout elements
    elementBorderRadius: "5px",
    elementShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);",
    elementBorder: "0px solid #e8e8e8",

    smallElementBorderRadius: "5px",
}

const stackerTheme = {
    ...vars,

    // Dividers, e.g. used in Tables

    // Spacing
    spaceXXS: "2px",
    xsmall: "4px",
    small: "8px",
    medium: "16px",
    large: "32px",
    xlarge: "64px",
    spaceXXL: "128px",

    // Tables
    columnHeadingWeight: "bold",
    columnHeadingColor: "unset",
    columnHeadingSize: "0.9em",
    rowHighlightColor: "#f6f8f9",

    // Element display

    // Headings etc.
    pageTitleSize: "28pt",
    pageTitleWeight: "bold",
    pageTitleFont: "Sharp-Sans",
    pageTitleColor: "#393942",

    // Buttons
    buttonFontColor: vars.fontColor,
    buttonColor: vars.surfaceColor,
    buttonBorderColor: vars.outlineColor,
    buttonBorderRadius: "5px",
    buttonBorderThickness: vars.borderThickness,

    // Headings
    headingOneSize: "24pt",
    headingTwoSize: "18pt",
    headingThreeSize: "14pt",
    headingWeight: "bold",
    headingFont: "Sharp-Sans",
    headingColor: vars.fontColor,
}
export default stackerTheme



// WEBPACK FOOTER //
// ./src/ui/styleHelpers/stackerTheme.js